import Component from '../abstracts/Component';

export default class SearchComponent extends Component {
  get SELECTORS() {
    return {
      searchInput: '[data-search-input]',
      resetSearchBtn: '[data-reset-search]',
      performSearchBtn: '[data-search-go]',
      performSearchIcon: '[data-search-icon]',
    };
  }

  constructor(compEl) {
    super(compEl);
    this.searchInput = this.$component.querySelector(
      this.SELECTORS.searchInput
    );
    this.resetSearchBtn = this.$component.querySelector(
      this.SELECTORS.resetSearchBtn
    );
    this.performSearchBtn = this.$component.querySelector(
      this.SELECTORS.performSearchBtn
    );
    this.performSearchIcon = this.$component.querySelector(
      this.SELECTORS.performSearchIcon
    );
  }

  render() {
    super.render();
    this.bindEvents();
  }

  bindEvents() {
    this.resetSearchBtn.addEventListener('click', () => {
      this.searchInput.value = '';
      this.resetSearchBtn.classList.add('hidden');
      this.performSearchBtn.classList.remove('hidden');
      this.performSearchIcon.classList.remove('hidden');
      this.searchInput.focus();
    });
  }
}
